import { createContext, useContext } from 'react';
import { useImmerReducer } from 'use-immer';

const maintenanceInit = {
    scheduledTime: null,
};

function maintenanceReducer ( draft, { type, payload } ) {
    switch (type) {
        case 'setScheduledTime': {
            draft.scheduledTime = payload.scheduledTime || null; // ensure we set the scheduled time
            break;
        }
        default: {
            return null;
        }
    }
}

const [MaintenanceContext, MaintenanceDispatchContext] = [createContext(null),createContext(null)];

export default function MaintenanceProvider ({ init, children }) {
    const [maintenanceStore, dispatch] = useImmerReducer(maintenanceReducer, init || maintenanceInit);

    return (
        <MaintenanceContext.Provider value={maintenanceStore}>
            <MaintenanceDispatchContext.Provider value={dispatch}>
                {children}
            </MaintenanceDispatchContext.Provider>
        </MaintenanceContext.Provider>
    )
}

export function useMaintenanceStore() {
    return useContext(MaintenanceContext);
}

export function useMaintenanceDispatch() {
    return useContext(MaintenanceDispatchContext);
}